import React, { Component, useEffect } from 'react'
import { pure } from 'recompose'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { List, ListSubHeader, ListCheckbox, ListItem } from 'react-toolbox/lib/list'
import { compose } from 'redux'
import { Flex } from 'reflexbox'
import { Button } from 'react-toolbox/lib/button'
import CollapseIconButton from '../CollapseIconButton'
import Collapse from 'components/fulcrum/collapse/Collapse'
import styles from './styles.scss'
import ListDivider from '../Dialog/Divider'

const PureListCheckbox = pure(ListCheckbox)
const SubFields = ({ 
  notCollapseable, 
  onClick, 
  caption, 
  list, 
  toggleSectionCollapse, 
  idx, 
  isSectionCollapsed,
  selectAllSearchSection
}) => {
  let temp = isSectionCollapsed
  if (temp === undefined) {
    temp = []
  }

  let searchSectionFilters = list.map((section) => {
    return section.value
  })

  let sectionSelected = true;
  list.forEach((filter) => {
    if (!filter.checked) {
      sectionSelected = false
      return
    }
  })
  
  return (
    <List
      selectable
      theme={styles}
    >
      <Flex>
        {notCollapseable ? <ListSubHeader caption={caption} /> : <Button
          label={caption}
          theme={styles}
          styleName={sectionSelected ? "selectedSectionTitle" : "unselectedSectionTitle" }
          onClick={() => selectAllSearchSection(searchSectionFilters)}
        />
        }
        <ListDivider/>
        {notCollapseable ? "" : 
        <CollapseIconButton
          onClick={() => toggleSectionCollapse(idx)}
          collapse={temp.indexOf(idx) !== -1}
          message='Collapse Search Filters'
        />}
      </Flex>
      <Collapse collapse={temp.indexOf(idx) !== -1}>
        { list.reduce((acc, { checked, index, type, value }, n) => {
          const checkbox = (
            <PureListCheckbox
              key={value}
              caption={type}
              checked={checked}
              onChange={(check) => onClick(check, value)}
              theme={styles}
              disabled={notCollapseable}
            />
        )
        acc.push(checkbox)
        notCollapseable ? acc.push(<ListDivider key={`${caption}_list_divider_${n}`}/>) : ''
        return acc
      }, [])}
      </Collapse>
    </List>
  )
}

SubFields.propTypes = {
  caption: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  // toggleSectionCollapse: PropTypes.func.isRequired,
  // isSectionCollapsed: PropTypes.array.isRequired
}

SubFields.defaultProps = {
  caption: '',
  list: [],
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(SubFields)
